import React from "react";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppFloatingButton from "@/components/site/WhatsAppFloatingButton";
import { Outlet, useLocation } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";

export default function SiteLayout() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    trackEvent("page_view", { path: pathname });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[#030712] text-slate-100">
      <Navbar />
      <main className="pt-16 sm:pt-20">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloatingButton />
    </div>
  );
}
